export default class Game {
	static WORLD_STATUS_ACTIVE = 1; // игровой мир активен
	static WORLD_STATUS_ENDED = 2; // игровой мир завершен
}